<script>
import KycTab from "../../components/Kyc/KycTab.vue";
import DigitalSign from "../../components/Kyc/DigitalSign.vue";
import UserDetail from "../UserDetail/index.vue";
import Photos from "../UserDetail/photos.vue";
import PersonalInfo from "../../components/Kyc/PersonalInfo/index.vue";
import Employment from "../../components/Kyc/Employment/index.vue";
import Document from "../../components/Kyc/Document/index.vue";
import {mapState} from "vuex";
import License from "../../components/License/index.vue";

export default {
  name: "index",
  components: {
    Photos,
    UserDetail,
    DigitalSign,
    KycTab,
    Employment,
    PersonalInfo,
    Document,
    License
  },
  computed: {
    ...mapState('user', ['user', 'kycStatus']),
    isCompany() {
      return this.user.individual === 'company'
    },
    isChildUser() {
      return ['child', 'children'].includes(this.user?.individual)
    },
    contracts() {
      return this.$store.getters['user/contracts']
    },
    main() {
      return this.contracts.find(contract => contract.type === 'main')
    },
    signStatus() {
      if (this.main && (this.main.status === 'user_signed' || this.main.status === 'admin_signed'))
        return 'done';
      // Гэрээ — өмнөх бүх алхам (хувийн мэдээлэл, ажил эрхлэлт, бичиг баримт, эрх нээлгэх) дууссан байх
      if (this.paymentStatus === 'done' && this.documentStepsDone)
        return 'current';
      return 'pending';
    },
    paymentStatus() {
      const payment = this.$store.getters['user/payment']
      if (payment && payment.FEE1 && payment.FEE1 === 'paid' && payment.FEE2 && payment.FEE2 === 'paid')
        return 'done';
      // Эрх нээлгэх — хувийн мэдээлэл, ажил эрхлэлт, бичиг баримт дууссан байх
      if (this.documentStepsDone)
        return 'current';
      return 'pending';
    },
    // Хувийн мэдээлэл, ажил эрхлэлт, бичиг баримт (1-3-р алхам) бүгд дууссан эсэх. Хүүхэд хэрэглэгчид 2, 3 нь 'done'.
    documentStepsDone() {
      return this.personalInfoStatus === 'done' && this.employmentStatus === 'done' && this.photoStatus === 'done';
    },
    personalInfoStatus() {
      if (this.isCompany) return 'pending';
      if (!!this.user.mobilenumber && this.kycStatus.profile && this.kycStatus.disability && this.kycStatus.address && this.kycStatus.current_address && this.kycStatus.bank_account)
        return 'done';
      return 'current';
    },
    employmentStatus() {
      if (this.isChildUser) return 'done';
      if (this.isCompany) return 'pending';
      if (this.kycStatus.employment_status && this.kycStatus.financial && this.kycStatus.monpep)
        return 'done';
      if (this.personalInfoStatus === 'done')
        return 'current';
      return 'pending';
    },
    photoStatus() {
      if (this.isChildUser) return 'done';
      if (this.isCompany) return 'pending';
      if (this.kycStatus.id_uploaded && (!this.kycStatus.is_disabled || this.kycStatus.disability_id_uploaded))
        return 'done';
      if (this.personalInfoStatus === 'done' && this.employmentStatus === 'done')
        return 'current';
      return 'pending';
    }
  },
  data() {
    return {
      selectedTabIndex: 1,
    }
  },

  async mounted() {
  const id = this.$route.query.access_token_id;
  if (!id) {
    return;
  }
  // Refresh хийхэд дахин татахгүйн тулд access_token_id-г URL-аас шууд арилгана
  this.$router.replace({ path: '/user/kyc' }).catch(() => {});

  this.$store.commit("user/SET_DAN_RESULT_LOADING", true);
  try {
    const res = await this.$axios.get(`/api/enduser/dan/result/${id}`);
    await this.$store.dispatch("user/setDanResult", res.data.data);
    await this.$store.dispatch("user/fetchUser");
  } catch (err) {
    const data = err.response?.data;
    if (data?.code === "ALREADY_REGISTERED") {
      this.$bvToast.toast(`Та ${data.data} хаягаар бүртгэлтэй байна`, {
        title: "Анхаар", variant: "warning"
      });
    } else {
      this.$bvToast.toast(data?.message || "Алдаа гарлаа", {
        title: "Алдаа", variant: "danger"
      });
    }
  } finally {
    this.$store.commit("user/SET_DAN_RESULT_LOADING", false);
  }
},

  watch: {
    kycStatus: {
      immediate: true,
      deep: true,
      handler() {
        this.updateSelectedTab();
      }
    },
    user: {
      immediate: true,
      handler() {
        this.updateSelectedTab();
      }
    }
  },
  methods: {
    updateSelectedTab() {
      if (!this.user) return;
      if (this.personalInfoStatus !== 'done') {
        this.selectedTabIndex = 1;
      } else if (!this.isChildUser && this.employmentStatus !== 'done') {
        this.selectedTabIndex = 2;
      } else if (!this.isChildUser && this.photoStatus !== 'done') {
        this.selectedTabIndex = 3;
      } else if (this.paymentStatus !== 'done') {
        this.selectedTabIndex = 4;
      } else if (this.signStatus !== 'done') {
        this.selectedTabIndex = 5;
      }
    },
    selectTab(val) {
      this.selectedTabIndex = val
    }
    
  }
}
</script>

<template>
  <div class="kyc-view" v-if="this.user">
    <div class="tab-row">
      <KycTab :text="$t('kyc.confirm.profile')" :index="1" :status="personalInfoStatus" @selectTab="selectTab" :active="selectedTabIndex === 1"/>
      <KycTab v-if="!isChildUser" :text="$t('kyc.employment')" :index="2" :status="employmentStatus" @selectTab="selectTab" :active="selectedTabIndex === 2"/>
      <KycTab v-if="!isChildUser" :text="$t('kyc.document')" :index="3" :status="photoStatus"  @selectTab="selectTab" :active="selectedTabIndex === 3"/>
      <KycTab :text="$t('kyc.activation')" :index="4" :status="paymentStatus" @selectTab="selectTab" :active="selectedTabIndex === 4"/>
      <KycTab :text="$t('kyc.agreement')" :index="5" :status="signStatus" @selectTab="selectTab" :active="selectedTabIndex === 5"/>
    </div>
    <div class="tab-content">
      <PersonalInfo v-if="selectedTabIndex === 1" @selectTab="selectTab"/>
      <Employment v-if="!isChildUser && selectedTabIndex === 2" @selectTab="selectTab"/>
      <Document v-if="!isChildUser && selectedTabIndex === 3" @selectTab="selectTab"/>
      <License v-if="selectedTabIndex === 4" @selectTab="selectTab"/>
      <DigitalSign v-if="selectedTabIndex === 5" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.kyc-view {
  display: flex;
}
.tab-row {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-basis: 220px;
}
.tab-content {
  flex: 1;
  padding: 24px;
  background-color: var(--sidebar-background);
  border-radius: 0px 20px 20px 20px;
  border-color: var(--sidebar-background);
  min-height: 320px;
}
</style>